import * as React from 'react';
import { NextPage } from 'next';
import Layout from '../components/layout';
import Reset from '../components/reset';

const ResetPage: NextPage = () => {
  return (
    <Layout>
      <Reset />
    </Layout>
  );
};

export default ResetPage;
